import type Currency from '../../../../types/payment/Currency';
import { pointsCurrency } from '../currency/getProperCurrencyByPaymentOption';

const isPointCurrency = (currency: Currency) => currency.code.toLowerCase() === pointsCurrency.code.toLowerCase();

export default isPointCurrency;
